module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head flex-space-between"
  }, [(!_vm.editing) ? _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.editing && _vm.isOwnerOrGroupAdmin) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm._title),
      expression: "_title"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Update title..."
    },
    domProps: {
      "value": (_vm._title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm._title = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.inComment && !_vm.editing && _vm.isOwnerOrGroupAdmin) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.editTag()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editing && _vm.isOwnerOrGroupAdmin) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.updateTag()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "mb-2 d-flex"
  }, [_c('strong', {
    staticClass: "mr-2"
  }, [_vm._v("Color:")]), _vm._v(" "), _c('span', {
    staticClass: "tag mr-2",
    style: ({
      'background-color': '#' + _vm.color
    })
  }), _vm._v(" "), (!_vm.editing) ? _c('span', [_vm._v(" #" + _vm._s(_vm.color))]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm._color),
      expression: "_color"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Update color..."
    },
    domProps: {
      "value": (_vm._color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm._color = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('strong', {
    staticClass: "mr-2"
  }, [_vm._v("Videos:")]), _vm._v(" "), _c('a', {
    staticClass: "mr-4",
    attrs: {
      "target": "_blank",
      "href": '/tags/' + _vm.id
    }
  }, [_vm._v("See list of videos with this tag")])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot flex-space-between"
  }, [(!_vm.inComment) ? _c('section', [_c('div', {
    staticClass: "flex-align-center"
  }, [_c('span', {
    staticClass: "mr-2 ml-2 text-bold bold"
  }, [_vm._v("Tag Share Settings")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    on: {
      "change": function($event) {
        _vm.updateTagShare($event, _vm.id)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    },
    domProps: {
      "selected": _vm.isOwner && _vm.groupTag == true
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    },
    domProps: {
      "selected": _vm.isOwner && _vm.groupTag == false
    }
  }, [_vm._v("Private")])])])]), _vm._v(" "), _c('span', {
    staticClass: "tag",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "data-balloon-length": "large",
      "data-balloon": 'Group Tag - This tag will show for every user\'s list in your group.   Private - This tag will only show on your list',
      "data-balloon-pos": "top"
    }
  }, [_vm._v("?")])])]) : _vm._e(), _vm._v(" "), (!_vm.inComment && _vm.isOwnerOrGroupAdmin) ? _c('button', {
    staticClass: "button is-small is-danger is-outlined pull-right",
    on: {
      "click": function($event) {
        _vm.prepTag(_vm.id)
      }
    }
  }, [_vm._v("Archive")]) : _vm._e()])]), _vm._v(" "), _c('Confirm', {
    attrs: {
      "show": _vm.showConfirm,
      "message": 'This will archive the tag for future use, but tags already applied to videos will remain.',
      "title": 'Archive Tag',
      "confirmFocus": true,
      "completeButtonText": 'Archive'
    },
    on: {
      "confirm": function($event) {
        _vm.archiveTag()
      },
      "cancel": function($event) {
        _vm.showConfirm = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-12d37497"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagOptionsModal.vue
// module id = 984
// module chunks = 0